import { BlockPalette, type BlockDef } from './BlockPalette.tsx';

interface BlockCatalogModalProps {
  title: string;
  blockDefs: BlockDef[];
  onAddBlock: (slug: string) => void;
  onClose: () => void;
}

export function BlockCatalogModal({ title, blockDefs, onAddBlock, onClose }: BlockCatalogModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col border border-gray-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200">
          <span className="text-sm font-semibold text-gray-900">{title}</span>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 p-1 rounded-lg hover:bg-gray-100"
          >
            ✕
          </button>
        </div>
        <BlockPalette
          blockDefs={blockDefs}
          columns={4}
          className="flex-1 overflow-y-auto"
          onAddBlock={(slug) => {
            onAddBlock(slug);
            onClose();
          }}
        />
      </div>
    </div>
  );
}
